window.OkCanary = () => {
	window.TheWebsiteOkCupidDotComAppearsToBeFunctioning = true;
};



// WEBPACK FOOTER //
// ./src/shared/util/Canary.js